// extracted by mini-css-extract-plugin
export default {"card-wrapper":"Cards_card-wrapper__gty-f","text":"Cards_text__2-Vuf","add-card":"Cards_add-card__e1dhl","add-card_footer":"Cards_add-card_footer__+jxX9"};